<template>
  <div v-if="loading" class="wrapper" @click="toMap">
    <div v-if="websiteInfo" class="page" :style="{backgroundImage:`url(${websiteInfo.mBg})`}">
      <div v-if="!websiteInfo.isBgOnly" class="footer">
        <img class="bg" src="@/assets/images/m-footer-bg.png">
        <div class="logo" :style="{backgroundImage:`url(${websiteInfo.mLogo})`,transform:`translateX(-50%) scale(${websiteInfo.mLogoScale})`}"></div>
        <div class="copyright">{{ websiteInfo.company }}</div>
      </div>
      <div v-if="!websiteInfo.isTouchOpen" class="loading-line"></div>
      <div v-if="!websiteInfo.isTouchOpen" class="loading-timer">{{ count }}s</div>
      <div v-if="websiteInfo.isTouchOpen && count > 0" class="loading-timer-tip">点击任意位置进入地图（{{ count }}s）</div>

      <!--		<div v-loading="true" class="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0)"></div>-->
    </div>
  </div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
        count:4
			}
		},

    watch:{
			websiteInfo(val){
        if(val){
          this.init()
        }
      }
    },

		computed: {
			websiteInfo() {
				return this.$store.state.user.websiteInfo || null
			}
		},

    methods:{
			init() {
				if(this.websiteInfo.isTouchOpen){
          this.timeCountTip()
				}else{
					this.timeCount();
				}
			},

			timeCountTip(){
				setTimeout(() => {
					this.count -= 1;
					if(this.count > 0){
						this.timeCountTip()
					}
				}, 1000);
      },

			timeCount(){
				setTimeout(() => {
					this.count -= 1;
					if(this.count > 0){
						this.timeCount()
					}else{
						this.loading = false;
					}
				}, 1000);
			},

			toMap(){
				if(this.websiteInfo.isTouchOpen){
					this.loading = false;
        }
      }
    }
	}
</script>

<style scoped>

  .wrapper{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color: #fff;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
  }
	.page {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 1000;
		background-color: #fff;
		background-position: top center;
		background-repeat: no-repeat;
		background-size: cover;
	}
	.footer {
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 0;
		display: block;
		z-index: 1;
	}

	.footer .bg {
		display: block;
		width: 100%;
	}

	.footer .logo {
		position: absolute;
		z-index: 1;
		left: 50%;
		bottom: 60px;
		transform: translateX(-50%);
		height: 130px;
		width: 130px;
		background-size: contain;
		background-position: center center;
		background-repeat: no-repeat;
		display: block;
		transform-origin: center bottom;
	}

	.footer .copyright {
		font-size: 12px;
		color: #9e9e9e;
		position: absolute;
		left: 0;
		bottom: 10px;
		width: 100%;
		text-align: center;
		z-index: 1;
		letter-spacing: 2px;
	}

	.loading {
		width: 100%;
		height: 30px;
		position: absolute;
		top: 0;
		background: rgba(255, 255, 255, 0.6);
		overflow: hidden;
		animation: breath 1.5s linear 0s infinite alternate;
		z-index: 2;
	}

	.loading ::v-deep .el-loading-spinner {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		width: 100%;
		top: 50%;
		transform: translateY(-50%);
		margin: 0;
		font-size: 12px;
	}

	.loading ::v-deep .el-icon-loading {
		margin-right: 5px;
	}

	::v-deep .el-loading-spinner .el-loading-text {
		z-index: 2;
		position: absolute;
		top: 0;
		height: 2px;
		background: #4e7aa0;
		width: 0;
	}

	.loading-line {
		z-index: 2;
		position: absolute;
		top: 0;
		height: 2px;
		background: linear-gradient(to right, #409eff, #d7eafe);
		width: 0;
		animation: grow 4s ease-in-out 0s;
		animation-fill-mode: both;
	}

	@keyframes grow {
		from {
			width: 0%;
		}
		to {
			width: 100%;
		}
	}

  .loading-timer{
    position: absolute;
    width:26px;
    height:26px;
    background: rgba(0,0,0,0.5);
    color:#fff;
    font-size:12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    top:10px;
    right:10px;
  }

  .loading-timer-tip{
    position: absolute;
    height:26px;
    padding: 0 10px;
    background: rgba(0,0,0,0.5);
    color:#fff;
    font-size:12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    top:50%;
    left:50%;
    transform: translateX(-50%) translateY(-50%);
    white-space: nowrap;
  }

	/*@keyframes breath {*/
	/*	form {*/
	/*		background: rgba(255, 255, 255, 0.6);*/
	/*	}*/
	/*	to {*/
	/*		background: rgba(255, 255, 255, 0.1);*/
	/*	}*/
	/*}*/

</style>
